import type { Theme } from 'baseui'
import { pulseLighting } from '@/shared/theme/pulseLighting'
import selectraPrimitives from '@/shared/theme/themePrimitives'

const withPulseFont = (typography: Theme['typography']): Theme['typography'] =>
  Object.fromEntries(
    Object.entries(typography).map(([name, font]) => [
      name,
      { ...font, fontFamily: selectraPrimitives.pulseFontFamily },
    ]),
  ) as Theme['typography']

const buildPulseTheme = (theme: Theme): Theme => {
  const { colors } = theme

  return {
    ...theme,
    colors: {
      ...colors,
      contentPrimary: colors.textPulseLabel,
      inputBorder: colors.borderPulseField,
      inputFill: colors.bgPulseField,
      inputFillActive: colors.white,
      inputFillDisabled: colors.bgPulseTrack,
      inputTextDisabled: colors.textPulseFaint,
      inputPlaceholder: colors.textPulsePlaceholder,
      borderSelected: colors.primaryPulse,
      borderFocus: colors.primaryPulse,
      buttonPrimaryFill: colors.primaryPulse,
      buttonPrimaryHover: colors.primaryPulseHover,
      buttonPrimaryActive: colors.primaryPulseHover,
      buttonSecondaryFill: colors.white,
      buttonSecondaryText: colors.textPulseStrong,
      buttonSecondaryHover: colors.bgPulseCanvas,
      buttonSecondaryActive: colors.bgPulseTrack,
      tooltipBackground: colors.white,
      tooltipText: colors.textPulseStrong,
      tickFillSelected: colors.primaryPulse,
      tickFillSelectedHover: colors.primaryPulseHover,
      tickBorder: colors.borderPulseHover,
      toggleFillChecked: colors.primaryPulse,
      toggleTrackFill: colors.bgPulseField,
      menuFill: colors.white,
      menuFillHover: colors.bgPulseTrack,
      menuFontSelected: colors.primaryPulse,
      menuFontHighlighted: colors.textPulseStrong,
    },
    typography: withPulseFont(theme.typography),
    borders: {
      ...theme.borders,
      inputBorderRadius: '8px',
      buttonBorderRadius: '8px',
      popoverBorderRadius: '10px',
    },
    lighting: {
      ...theme.lighting,
      shadow600: pulseLighting(theme).shadowPulsePopover,
    },
  }
}

export default buildPulseTheme
